export const isConnect = () => process.env.VITE_CONNECT === 'true';
